import NodeDataStore from "csi/datastore/NodeDataStore";
import types from "csi/types";
import { C8Node, IDataStore } from "csi/typings";
import xml from "csi/xml";
import { ILocaleProvider, useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import "src/css/variables.css";
import { classes, ComplianceAnalysisCard } from "./ComplianceAnalysisCard";


/**
 * ComplianceAnalysis Entry message Format:
 * NodeName
 * {AnalysisStatus}
 * {ParentDataSheetRevisionState}
 * {Request Sent time}
 * {AnalysisType}
 * {ComplianceSystemResultsUIURL }
*/

export interface ComplianceAnalysisCardFLDSProps
{
	className?: string;
	id: string;
	item: C8Node;
	onClick: VoidFunction;
	onDelete?: VoidFunction;
	selected?: boolean;
	selecting?: boolean;
	store: IDataStore<C8Node>;
	additionalProps?: Object;
}

export const ComplianceAnalysisCardFLDS: FunctionComponent<ComplianceAnalysisCardFLDSProps> = (props) => {
	const { className, id, item, onClick, onDelete, selected, selecting, store, additionalProps } = props;
	const loc: ILocaleProvider = useLocale();
	const { cache: typeCache } = additionalProps["typeStore"] as NodeDataStore;

	const nodeName = item["Node Name"];
	const revState = loc.enumResource(item.ParentDataSheetRevisionState);
	const stateCssClass = "csi-name-value-pair csi-state csi-state-" + revState.toLowerCase();
	const analysisState = loc.resource("AnalysisStatus", [item.AnalysisStatus]);
	const requestSentTime = loc.resource("RequestSentTime", [types.formatTime(item.$CT, types.FORMAT_DATETIME)]);
	const analysisType = loc.resource("AnalysisType", [typeCache.get(item.AnalysisType)?.$Name]);
	const analysisURL = loc.resource("ComplianceSystemResultsUIURL") + ": ";

	const panelContent: FunctionComponent = () => {
		return (
			<div className={classes.panelCard}>
				<div className={classes.nodeName}>
					{nodeName}
				</div>
				<div className={classes.text}>
					{analysisState}
				</div>
				<div className={classes.text}>
					<span className={stateCssClass}>{revState}</span>
				</div>
				<div className={classes.text}>
					{requestSentTime}
				</div>
				<div className={classes.text}>
					{analysisType}
				</div>
				<div className={classes.text}>
					{analysisURL} <a href={item.ComplianceSystemResultsUIURL} target="_blank">{item.ComplianceSystemResultsUIURL}</a>
				</div>
			</div>
		);
	};

	return (
		<ComplianceAnalysisCard
			PanelContent={panelContent}
			cardDesignType="list"
			className={className}
			id={id}
			item={item}
			onClick={onClick}
			onDelete={onDelete}
			selected={selected}
			selecting={selecting}
			store={store}
		/>
	);
};
